export const isArrayAndNotEmpty = (array: any[]) => Array.isArray(array) && array.length > 0;
export const isArrayWithNotEmptyValues = (array: any[]) =>
  isArrayAndNotEmpty(array) && array.every((item) => item !== null && item !== undefined);
